import { pathValid } from './path-valid';

export class PathData {
	public history: pathValid[] = [];
	public path: pathValid;

	public iComingFrom3D: boolean;

	constructor () {
		this.history = ['/hold'];
		this.path = '/hold';
		this.iComingFrom3D = false;
	}
}
